import { useMemo } from 'react';

import type { EditorState } from '@atlaskit/editor-prosemirror/state';
import { fg } from '@atlaskit/platform-feature-flags';
import { type EditorAgent } from '@atlassian/generative-ai-modal/utils/agents';

import { rovoAgentsPluginKey } from './plugin-key';

type UseAgentProps = {
	editorState?: EditorState;
};

export function useAgents({ editorState }: UseAgentProps): EditorAgent[] {
	const rovoAgentsState = useMemo(() => {
		if (!fg('platform.editor.ai-rovo-agents') || !editorState) {
			return;
		}

		return rovoAgentsPluginKey.getState(editorState);
	}, [editorState]);

	return useMemo(() => rovoAgentsState?.agents ?? [], [rovoAgentsState]);
}
